import React, { useState, useEffect } from 'react';
import { getFirestore, doc, updateDoc, Timestamp } from 'firebase/firestore';
import { useFireAuth } from '../FireAuthContext';
import useBank from './useBank';
import './Rewards.css';

const Rewards = ({ onRewardClaimed }) => {
  const [canClaim, setCanClaim] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const { user, updateUser } = useFireAuth();
  const { withdrawMoney } = useBank();

  useEffect(() => {
    const checkRewardEligibility = async () => {
      if (!user || !user.lastDailyReward) {
        setCanClaim(true);
        return;
      }

      const now = Timestamp.now();
      const lastReward = user.lastDailyReward;
      const diffInSeconds = now.seconds - lastReward.seconds;
      const hoursRemaining = 24 - (diffInSeconds / 3600);

      if (hoursRemaining <= 0) {
        setCanClaim(true);
        setTimeRemaining(null);
      } else {
        setCanClaim(false);
        setTimeRemaining(hoursRemaining);
      }
    };

    if (user) {
      checkRewardEligibility();
    }
  }, [user]);

  const claimReward = async () => {
    if (!canClaim || isProcessing) {
      return;
    }

    if (!user || !user.uid) {
      return;
    }

    setIsProcessing(true);

    const db = getFirestore();
    const userRef = doc(db, 'users', user.uid);

    try {
      await withdrawMoney(20, false);
      
      await updateDoc(userRef, {
        lastDailyReward: Timestamp.now()
      });

      setCanClaim(false);
      setMessage('You have claimed your daily reward of 20 credits!');
      
      await updateUser();
      
      if (onRewardClaimed) {
        onRewardClaimed();
      }

      setTimeout(() => setMessage(''), 5000);
    } catch (error) {
      console.error('Error claiming reward:', error);
      setMessage(`Failed to claim reward: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="rewards-container">
      <h3>Daily Reward</h3>
      {message && <p className="reward-message">{message}</p>}
      {!message && (
        canClaim ? (
          <button 
            onClick={claimReward} 
            className="claim-button" 
            disabled={isProcessing}
          >
            {isProcessing ? 'Processing...' : 'Claim 20 Credits'}
          </button>
        ) : (
          <p>Next reward available in: {timeRemaining ? `${Math.ceil(timeRemaining)} hours` : 'Loading...'}</p>
        )
      )}
    </div>
  );
};

export default Rewards;
